import React from 'react';
import { Select, Tooltip, type SelectProps } from 'antd';
import { type OperatorSelectorProps } from 'react-querybuilder';
import { getFieldSchema, allowMultiSelection, getOperators } from '../utils';
import { type QueryBuilderFieldSchema, type QueryBuilderContext } from '../types';

const defaultOperatorsOptions = getOperators();

const Operator = (props: OperatorSelectorProps) => {
  const { rule, schema, path, context } = props;
  const fieldSchema = getFieldSchema(rule.field, schema.fields as QueryBuilderFieldSchema[]);
  const { onOperatorChange } = context as QueryBuilderContext;

  const options = (fieldSchema?.operatorOptions ?? defaultOperatorsOptions).map((it) => {
    const disabled = !allowMultiSelection(it.value) && rule.value?.length > 1;
    return {
      ...it,
      label: disabled ? (
        <Tooltip title="Use a Group to implement not_equals/not_contains for multiple values">
          <div style={{ opacity: 0.5 }}>{it.label}</div>
        </Tooltip>
      ) : (
        it.label
      ),
      disabled,
    };
  }) as SelectProps['options'];

  return (
    <Select
      disabled={!fieldSchema}
      style={{ width: 130 }}
      value={rule.operator}
      options={options}
      onChange={(data) => {
        if (fieldSchema) {
          onOperatorChange(data, path, fieldSchema);
        }
      }}
    />
  );
};

export default React.memo(Operator);
